'use strict';

/**
 * Module definition file
 *
 * All services, controllers, and directives are registered with angular here
 * 
 * Bower dependencies should NOT be require here. They should be required in tests/lib.js.
 */

var cp = angular.module('saturn.colorpicker', []);

var ColorpickerController = require('./ColorpickerController');
var ColorpickerDirective = require('./ColorpickerDirective');
var ColorpickerProvider = require('./ColorpickerProvider');

cp.controller('sbColorpickerController', [
  '$scope',
  'sbColorpicker',
  ColorpickerController
]);

cp.directive('sbColorpicker', [
  '$compile',
  '$interpolate',
  '$templateCache',
  ColorpickerDirective
]);

cp.provider('sbColorpicker', [
  ColorpickerProvider
]);

// ## Template Module
require('./templates.js');



// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/colorpicker/src/index.js